import styles from "./prize.module.css"

export default function PrizePool({ prizePool }) {
  return (
    <div className={styles.prizeCard}>
      <h2 className={styles.sectionTitle}>Prize Pool</h2>
      <div className={styles.prizeContent}>
        {prizePool.split("|").map((prize, index) => (
          <div key={index} className={styles.prizeItem}>
            <span>{prize.trim()}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
